import React, { useState, useEffect } from "react";
import { Col, Row } from "reactstrap";
import { isMobile } from "../../../utils/deviceInfo";
import MessagingTriviaResultsResponses from "./Results/MessagingTriviaResultsResponses";
import MessagingTriviaResultsSummary from "./Results/MessagingTriviaResultsSummary";
import TriviaResultsRatings from "./TriviaResultsRatings";
import TriviaResultsResponses from "./TriviaResultsResponses";
import TriviaResultsSummary from "./TriviaResultsSummaryPublic";
import { withRouter } from "react-router-dom";
import { Redirect, Route, Switch } from "react-router";
import TriviaResultsInsights from "./TriviaResultsInsights";
import moment from 'moment'

function TriviaResultsComponentPublic({ currentTrivia, ...props }) {
  const [tab, setTab] = useState(1);


  useEffect(() => {
    const currentBlock = props.match.params.tab;

    if (currentBlock == "results-summary") {
      setTab(1)
    }
    if (currentBlock == "results-responses") {
      setTab(2)
    }
    if (currentBlock == "results-insights"  || currentBlock == "results") {
      setTab(3)
    }
  }, [])

  console.log('hello here')

  const changeTab = (tab) => {

    props.history.push(`results-${tab == 1 ? "summary" : tab == 2 ? "responses" : tab == 3 ? "insights" : "insights"}`);
    setTab(tab);
  };
  console.log(currentTrivia,'here')

  if (currentTrivia) {
    return (
      <div id={"trivvy_result_wrapper"}>
        <div>
          <Row className="bg-white top-trivia-results-share-row">
            <Col sm={2}></Col>
            <Col sm={8}>
              <div className="bg-white">
                <ul
                  className="data-user trivia-edit-top-nav-survey-ui"
                  style={{
                    width: isMobile ? "inherit" : "400px",
                    marginBottom:"-2px",
                    margin:"0",
                    textAlign:"left"
                  }}
                >
            

                  
              {/* <li>
                    <a
                      className={`res_menu_option ${tab == 1 ? "profile_page_menu_option_active" : ""
                        }`}
                      onClick={() => changeTab(1)}
                      style={{
                        // width: isMobile ? "inherit" : "200px",
                        margin:"auto",
                        borderBottom:"none"
                      }}
                    >
                      {currentTrivia && currentTrivia.name || "By Question"}
                    </a>
                  </li> */}

                  <li>
                    <a
                      className={`res_menu_option ${
                        tab == 1 ? "profile_page_menu_option_active" : ""
                      }`}
                      onClick={() => changeTab(1)}
                      style={{
                        margin: "auto 0", // remove centering
                        borderBottom: "none",
                        textAlign: "left", // left-justify text
                      }}
                    >
                      <div style={{ fontSize: "1.5em", fontWeight: "bold" }}>
                        {currentTrivia && currentTrivia.name || "By Question"}
                      </div>
                      <div style={{ fontSize: "0.9em", color: "#666" }}>
                        Exported on: {moment().format("MMMM Do YYYY")}
                      </div>
                    </a>
                  </li>
                  

                 



                  {/* <li>
                    <a
                      className={`${
                        tab == 3 ? "profile_page_menu_option_active" : ""
                      }`}
                      onClick={() => changeTab(3)}
                    >
                      Rating
                    </a>
                  </li> */}
                </ul>
              </div>
            </Col>
            <Col sm={2}></Col>
          </Row>
        </div>
        <Row className="TriviaResultsResponsesContainer trivia_results_section_ui_height_wrapper" style={{height:"auto"}}>
        

       <Col sm={9}>
         
                <TriviaResultsSummary
                  questions={currentTrivia.questions}
                  surveyId={currentTrivia._id}
                  allowAttempts={currentTrivia.allowAttempts}
                  currentTrivvy={currentTrivia}
                  setCurrentTrivia={props.setCurrentTrivia}
                  user={props.user.profile}
                  public={true}                />
             
            </Col>
          

        </Row>
      </div>
    );
  } else {
    return <div></div>;
  }
}

export default withRouter(TriviaResultsComponentPublic);
